import React from 'react';
import { tamAljanubContent } from '../rich-content/tam-aljanub-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const TamAljanubDetailPage = () => {
  return <AutomaticPageBuilder content={tamAljanubContent} />;
};

export default TamAljanubDetailPage;
